import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { IGetState } from '../../../../../types/types';
import { fetchHandler } from '../../../../../util/fetchHandler';
import { REST_CHATS } from '../../../../constants';
import { getRestHeadersGet } from '../../../../helpers/getRestHeadersHelper';
import { Util } from '../../../../../util/util';
import { IChatGroup } from '../types';
import { TChatGroupId } from 'app/types/rest/IRestChatGroup';

export const getByIdRest = (
    id: TChatGroupId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<IChatGroup>(
            Util.getApiUrl(
                REST_CHATS + `groups/${id}`),
                getRestHeadersGet(),
        );
    };
    return action;
};
